module.exports = __webpack_public_path__ + "assets/img/thumb-logitech-astrogaming.257d3218.jpg";